import { useQuery } from "@tanstack/react-query";
import { qualifyUrl } from "util/URLUtils";
import fetch from "logic/rest/FetchProvider";
import { defaultOnError } from "util/conditional/onError";
export const fetchDataLakeConnectorById = async (id) => fetch(
  "GET",
  qualifyUrl(`/plugins/org.graylog.plugins.datalake.externaldatalake.datasources.athena/athena/credentials/${id}`)
);
const useDataLakeConnectorById = (id) => {
  const { data, refetch, isLoading, error } = useQuery({
    queryKey: ["data-lake-connector-by-id", id],
    queryFn: () => defaultOnError(
      fetchDataLakeConnectorById(id),
      "Loading Data Lake Connector failed with status",
      "Could not load Data Lake Connector."
    ),
    notifyOnChangeProps: ["data", "error"],
    enabled: !!id
  });
  return {
    data,
    refetch,
    isLoading,
    error
  };
};
export default useDataLakeConnectorById;
